import React from 'react';
import RemoveConfirmationModal from '../../../../Components/RemoveConfirmation/RemoveConfirmationModal';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import { useAppContext } from '../../../../Services/AppContext';
import LinkButton from '../../../../Components/Button/LinkButton';

interface HealthPlanPrintPdfModalProps {
	opened: boolean;
	onClose: any;
	healthPlanUser: any;
	healthPlanUserItem: any;
}

export default function HealthPlanPrintPdfModal(
	props: HealthPlanPrintPdfModalProps,
) {
	const { opened, onClose, healthPlanUser, healthPlanUserItem } = props;
	const { socketUrl } = useAppContext();

	return (
		<>
			<RemoveConfirmationModal
				opened={opened}
				onClose={onClose}
				confirmationText={'base.printWindow.text'}
				confirmationTitle={'base.printWindow.title'}
				customButtons={(onClose: any) => (
					<React.Fragment>
						<LinkButton
							title='base.shared.confirm'
							theme={Theme.GREEN}
							displayAsButton
							href={`${socketUrl}/health-plan/${healthPlanUser?.healthPlanId}/user/${healthPlanUser?.id}/item/${healthPlanUserItem?.id}/pdf?print&withPermit`}
							onClick={onClose}
							firstUpper
						/>
						<Button
							onClick={() => {
								onClose();
							}}
							title={'base.shared.cancel'}
							theme={Theme.RED}
						/>
					</React.Fragment>
				)}
				showAbort={false}
			/>
		</>
	);
}
